import { render, staticRenderFns } from "./repassword.vue?vue&type=template&id=2abbe6ab&scoped=true&"
import script from "./repassword.vue?vue&type=script&lang=js&"
export * from "./repassword.vue?vue&type=script&lang=js&"
import style0 from "./repassword.vue?vue&type=style&index=0&id=2abbe6ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbe6ab",
  null
  
)

export default component.exports